import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=3b8fad7c&scoped=true&"
import script from "./CloseIcon.vue?vue&type=script&lang=ts&"
export * from "./CloseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=3b8fad7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8fad7c",
  null
  
)

export default component.exports